import { useState } from "react";
import { DownloadOutlined, EnvironmentOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps, Pagination } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { cardData } from "../scripts/products";
import ProductModal from "../components/modals/productModal";

export const Products = () => {
  const [current, setCurrent] = useState(1);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const items: MenuProps["items"] = [
    {
      label: "Cкачать шаблон",
      key: "download",
      icon: <DownloadOutlined />,
    },
    {
      label: "Загрузить",
      key: "upload",
      icon: <UploadOutlined />,
    },
  ];

  const onChange = (page: any) => {
    setCurrent(page);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  let products = cardData.filter((item) =>
    item.seller.includes("Ново-Ярославск")
  );

  return (
    <div className="App">
      <div className="white-back">
        <div className="flex-end">
          <p>Всего товаров: {products?.length}</p>
          <div className="flex-right">
            <Button type="primary" onClick={() => setModalOpen(true)}>
              <PlusOutlined /> Добавить продукт
            </Button>

            <Dropdown
              menu={{
                items,
                selectable: true,
                defaultSelectedKeys: ["2"],
                //onClick,
              }}
            >
              <Button onClick={(e) => e.preventDefault()}>
                Импортировать продукты
              </Button>
            </Dropdown>
          </div>
        </div>
        <div className="catalog">
          {products
            .slice((current - 1) * 10, (current - 1) * 10 + 10)
            .map(({ id, images, price, title, seller }, index) => (
              <div
                className="card"
                key={index}
                onClick={() => navigate(`/product/${id}`)}
              >
                {images?.length > 0 ? (
                  images?.length > 1 ? (
                    <Slider {...settings}>
                      {images.map((img, i) => (
                        <div>
                          <img
                            src={img}
                            alt={title}
                            key={i}
                            className={"image"}
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <img src={images[0]} alt={title} className={"image"} />
                  )
                ) : (
                  <img src={"/not-image.png"} className={"image"} />
                )}

                <div>
                  <p className="title">{price?.toLocaleString("ru-RU")} ₽</p>
                  <p className="title">{title}</p>

                  <p className="sub_title">{seller}</p>
                </div>
              </div>
            ))}
        </div>
        <Pagination
          onChange={onChange}
          current={current}
          total={products?.length}
          pageSize={10}
        />
      </div>
      <ProductModal open={modalOpen} isCloseModal={closeModal} />
    </div>
  );
};
